import 'bootstrap/dist/js/bootstrap.min';
import "bootstrap-datepicker/dist/js/bootstrap-datepicker.min";
import "bootstrap-datepicker/js/locales/bootstrap-datepicker.it";
//import "clipboard";



// WEBPACK FOOTER //
// ./scripts/autoload/_bootstrap.js